// Copyright (c) Mysten Labs, Inc.
// Modifications Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

import { DisplayStats } from '@iota/apps-ui-kit';
import { AddressLink, CheckpointSequenceLink, DateDisplay, EpochLink } from '~/components';
import { onCopySuccess } from '~/lib/utils';

interface TransactionDetailsProps {
    sender?: string;
    checkpoint?: string | null;
    executedEpoch?: string;
    timestamp?: string | null;
}

export function TransactionDetails({
    sender,
    checkpoint,
    executedEpoch,
    timestamp,
}: TransactionDetailsProps): JSX.Element {
    return (
        <div className="grid grid-cols-1 gap-sm md:grid-cols-4">
            {sender && (
                <DisplayStats
                    label="Sender"
                    value={
                        <div className="flex flex-col gap-y-xxs">
                            <AddressLink address={sender} copyText={sender} />
                        </div>
                    }
                />
            )}
            {checkpoint && (
                <DisplayStats
                    label="Checkpoint"
                    value={
                        <CheckpointSequenceLink sequence={checkpoint}>
                            {Number(checkpoint).toLocaleString()}
                        </CheckpointSequenceLink>
                    }
                    copyText={checkpoint}
                    onCopySuccess={onCopySuccess}
                />
            )}
            {executedEpoch && (
                <DisplayStats
                    label="Epoch"
                    value={<EpochLink epoch={executedEpoch}>{executedEpoch}</EpochLink>}
                />
            )}

            {timestamp && (
                <DisplayStats
                    label="Date"
                    value={<DateDisplay timestamp={timestamp} type="transaction" showTimeAgo />}
                />
            )}
        </div>
    );
}
